const fonts = [
  {
    '@font-face': {
      fontFamily: 'primary',
      src: `url('/fonts/Montserrat/Montserrat-Regular.ttf') format('truetype')`,
      fontWeight: 400,
      fontStyle: 'normal',
    },
  },

  {
    '@font-face': {
      fontFamily: 'secondary',
      src: `url('/fonts/Montserrat/Montserrat-Light.ttf') format('truetype')`,
      fontWeight: 300,
      fontStyle: 'normal',
    },
  },
];

export default fonts;
